import { Injectable } from '@angular/core';
import { createSelector, select, Store } from '@ngrx/store';
import { map, Observable } from 'rxjs';

import { GridItemEntity } from '../components/grid-list/grid-item.entity';
import { GridListEntity } from '../components/grid-list/grid-list.entity';
import { featureSelector, GridRootState } from './feature.store';
import { GridOriginalSliceState, GridSliceKey } from './grid.state';

const baseSelector = createSelector(
	featureSelector,
	(state) => state[GridSliceKey]
);

const listSelector = createSelector(baseSelector, (state) => state.list);

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const gridById = (id: number) =>
	createSelector(listSelector, (list) => list.elements.get(`${id}`));

@Injectable()
export class GridSelector {
	public constructor(private readonly store: Store<GridRootState>) {}

	private get state(): Observable<GridOriginalSliceState> {
		return this.store.pipe(select(baseSelector));
	}
	public getLoading$(): Observable<boolean> {
		return this.state.pipe(map((state) => state.get('loading')));
	}
	public getGridList$(): Observable<GridListEntity> {
		return this.state.pipe(map((state) => state.get('list')));
	}

	public getSuccessDeleteGrids$(): Observable<boolean> {
		return this.state.pipe(map((state) => state.get('deleteSuccess')));
	}

	public getMedia$(id: number): Observable<GridItemEntity | undefined> {
		return this.store.pipe(select(gridById(id)));
	}

	public getSelectedGrids$(
		selected: Array<string>
	): Observable<Array<GridItemEntity>> {
		return this.getGridList$().pipe(
			map((list) =>
				selected.reduce<Array<GridItemEntity>>((acc, curr) => {
					const maybe = list.elements.get(`${curr}`);
					if (maybe) {
						acc.push(maybe);
						return acc;
					}
					return acc;
				}, [])
			)
		);
	}
}
